module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-container",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      },
      "click": function($event) {
        _vm.closeFilter()
      }
    }
  }, [_c('div', {
    staticClass: "top-container-content"
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v("优惠")]), _vm._v(" "), _c('div', {
    staticClass: "filter-content"
  }, [_c('div', {
    class: _vm.classArray.quan.className[0],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.addParam(_vm.classArray.quan.type, 0, '&dpyhq=false')
      }
    }
  }, [_vm._v("全部商品")]), _vm._v(" "), _c('div', {
    class: _vm.classArray.quan.className[1],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.addParam(_vm.classArray.quan.type, 1, '')
      }
    }
  }, [_vm._v("有券商品")])])]), _vm._v(" "), (!_vm.isWeixin) ? _c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v("店铺")]), _vm._v(" "), _c('div', {
    staticClass: "filter-content"
  }, [_c('div', {
    class: _vm.classArray.shop.className[0],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.addParam(_vm.classArray.shop.type, 0, '')
      }
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('div', {
    class: _vm.classArray.shop.className[1],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.addParam(_vm.classArray.shop.type, 1, '&tmall=true')
      }
    }
  }, [_vm._v("天猫")])])]) : _c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v("店铺")]), _vm._v(" "), _c('div', {
    staticClass: "filter-content"
  }, [_c('div', {
    class: _vm.classArray.shop.className[0],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.addParam(_vm.classArray.shop.type, 0, '')
      }
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('div', {
    class: _vm.classArray.shop.className[1],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.addParam(_vm.classArray.shop.type, 1, '&jd_only=1')
      }
    }
  }, [_vm._v("京东")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-content"
  }, [_c('div', {
    class: _vm.classArray.shop.className[2],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.addParam(_vm.classArray.shop.type, 2, '&pdd_only=1')
      }
    }
  }, [_vm._v("拼多多")]), _vm._v(" "), _c('div', {
    staticClass: "item-right-null"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v("价格")]), _vm._v(" "), _c('div', {
    staticClass: "filter-content"
  }, [_c('div', {
    class: _vm.classArray.price.className[0],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.addParam(_vm.classArray.price.type, 0, '&endprice=10')
      }
    }
  }, [_vm._v("小于10元")]), _vm._v(" "), _c('div', {
    class: _vm.classArray.price.className[1],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.addParam(_vm.classArray.price.type, 1, '&startprice=10&endprice=20')
      }
    }
  }, [_vm._v("10-20元")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-content"
  }, [_c('div', {
    class: _vm.classArray.price.className[2],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.addParam(_vm.classArray.price.type, 2, '&startprice=20&endprice=50')
      }
    }
  }, [_vm._v("20-50元")]), _vm._v(" "), _c('div', {
    class: _vm.classArray.price.className[3],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.addParam(_vm.classArray.price.type, 3, '&startprice=50')
      }
    }
  }, [_vm._v("50元以上")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-content"
  }, [_c('div', {
    class: _vm.classArray.price.className[4],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.addParam(_vm.classArray.price.type, 4, '')
      }
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('div', {
    staticClass: "item-right-null"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter",
    on: {
      "click": _vm.addParam
    }
  }, [_vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-content"
  }, [_c('div', {
    staticClass: "item-center"
  }, [_vm._v("重置")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52084be8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Filter.vue
// module id = 203
// module chunks = 2